import NextImage from 'next/image';
import { supabaseImageLoader } from '../../lib/imageLoader';

export const Img = ({ src, ...props }: any) => {
  if (!src) return <></>;

  if (typeof src === 'object' && src.hasOwnProperty('filename')) {
    const supabaseUrl = supabaseImageLoader({
      src: src.filename,
      width: 0,
      quality: 85,
    });
    return <NextImage src={supabaseUrl} {...props} />;
  }

  if (src?.includes('http') && !src?.includes('coverstori')) {
    return <img src={src} {...props} />;
  }

  const supabaseUrl = supabaseImageLoader({ src, width: 0, quality: 85 });
  return <NextImage src={supabaseUrl} {...props} />;
};
